var styleDataHash = 'e664c4c6';  
export const injectCss = (() => {
  var css = `.noJKv,.noJKv:visited{background:var(--ricos-custom-mention-background-color,transparent)!important;border-radius:2px;color:var(--ricos-custom-mention-color,var(--ricos-action-color,#116dff));display:inline-block;padding-left:2px;padding-right:2px;text-decoration:none}.aRX4O,.aRX4O:visited{padding-left:4px;padding-right:4px}.noJKv:focus,.noJKv:hover{outline:0;text-decoration:underline}.noJKv:active,.noJKv:focus,.noJKv:hover{color:var(--ricos-custom-mention-color,var(--ricos-action-color,#116dff))}.MziBz{cursor:default}.mfAe5{cursor:pointer}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





